import Error from './components/error';
import { routes as SignIn } from './SignIn/routes';
import { routes as SignOut } from './SignOut/routes';
import { routes as ForceChallenge } from './ForceChallenge/routes';

export const routes = [
  { path: '/error', name: 'error', component: Error, display: '', style: '' },
  ...SignIn,
  ...SignOut,
  ...ForceChallenge
];
